import type { AbsolutePath } from '@hub/router';
import type { ReactNode } from 'react';
import { useContext } from 'react';
import { QuickActionStatusContext } from './QuickActionStatusContext';

/** The severity marker for a quick-action row, or `undefined` when it has none. */
export function useQuickActionStatus(): (to: AbsolutePath) => ReactNode | undefined {
  const context = useContext(QuickActionStatusContext);
  return (to) => context?.status[to];
}
